module.exports = __webpack_public_path__ + "static/media/isro_logo.2b17dc24.png";